import React, { Component } from 'react';
import './SelectDropDown.scss';
import { Form } from 'react-bootstrap';
import dropDownIcon from '../../Assets/images/commonImages/dropdown_icon.svg';

type initialState = {};
type initialProps = {
    options: any;
    placeholder?: string;
    onChange: any;
    disabled?: boolean;
    value?: string;
    disabledText?: boolean;
    className?:any;
    showDropDownIcon?:boolean;
};
export class SelectDropDown extends Component<initialProps, initialState> {
    render() {
        return (
            <div className="SelectDropdown">
                <Form.Select
                    as="select"
                    value={this.props.value}
                    // className="selectInput"
                    className={`selectInput ${this.props.className}`}
                    disabled={this.props.disabled}
                    onChange={this.props.onChange.bind(this)}
                >
                    <option className="d-none">{this.props.value ? this.props.value : this.props.placeholder}</option>
                    {!this.props.disabledText && (
                        <option className="SelectOptions" disabled value="">
                            {this.props.placeholder}
                        </option>
                    )}
                    {this.props.options.map((option: any) => (
                        <option
                            className="SelectOptions"
                            // onSelect={(e: any) => console.log(e, option.label)}
                            key={option.value ? option.value : option.countryCode}
                            value={option.label ? option.value : option.countryName}
                        >
                            {option.label ? option.label : option.countryName}
                        </option>
                    ))}
                </Form.Select>
                {this.props.showDropDownIcon && <img src={dropDownIcon} alt="dropDownIcon" className='dropDownIcon'/>}
            </div>
        );
    }
}

export default SelectDropDown;
